var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.25,
    fill: "url(#paint0_linear_3135_40034)",
    stroke: "url(#paint1_linear_3135_40034)",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 6.00049L9.4375 15.6255L6 11.8755",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3135_40034",
    x1: 11.5,
    y1: 0.5,
    x2: 16.7039,
    y2: 28.6474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3135_40034",
    x1: 11.5,
    y1: 0.5,
    x2: 16.7039,
    y2: 28.6474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/CheckCircleIcon.c54692a681d122fbccc5af76e6b01c81.svg";
export { ForwardRef as ReactComponent };